// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.merchant-slide-section {
  padding: 0px 10%;
}

.slide-image {
  width: 100px !important;
  height: 100px;
  object-fit: cover;
  background-color: white;
}

.merchant-slide-text {
  font-size: 45px;
  line-height: 30px;
}

@media only screen and (max-width: 1811px) {
  .Merchant-slide-container {
    display: flex !important;
  }
  .merchant-slide {
    display: flex !important;
    flex-wrap: nowrap !important;
    overflow: auto !important;
    margin: 0 !important;
    width: 100%;
  }
  .merchant-slide-text {
    width: 100% !important;
  }
}
@media only screen and (max-width: 1545px) {
  .merchant-slide-text {
    width: 250px !important;
  }
  .merchant-slide-section {
    margin-left: 0%;
  }
}
@media only screen and (max-width: 992px) {
  .Merchant-slide-container {
    display: inline !important;
    padding: 0px 10% !important;
  }
  .merchant-slide-text {
    padding-left: 5% !important;
    width: 250px !important;
  }
}
@media only screen and (max-width: 820px) {
  .merchant-slide-text {
    padding-left: 10%;
    width: 250px !important;
  }
}
@media only screen and (max-width: 570px) {
  .Merchant-slide-container {
    display: inline !important;
  }
  .merchant-slide-text {
    padding-left: 2%;
    width: 500px !important;
    font-size: 30px;
    line-height: 15px;
    margin-bottom: 10%;
  }
}
@media only screen and (max-width: 559px) {
  .Merchant-slide-container {
    width: 100% !important;
  }
  .merchant-slide-text {
    width: 100% !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/presentation/main/sell-with-pamo/component/merchant-slide/merchant-slide.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAGA;EACE,uBAAA;EACA,aAAA;EACA,iBAAA;EACA,uBAAA;AAAF;;AAEA;EAEE,eAAA;EACA,iBAAA;AAAF;;AAGA;EACE;IACE,wBAAA;EAAF;EAGA;IACE,wBAAA;IACA,4BAAA;IACA,yBAAA;IACA,oBAAA;IACA,WAAA;EADF;EAKA;IACE,sBAAA;EAHF;AACF;AAWA;EAGE;IACE,uBAAA;EAXF;EAcA;IACE,eAAA;EAZF;AACF;AAeA;EAEE;IACE,0BAAA;IACA,2BAAA;EAdF;EAiBA;IACE,2BAAA;IACA,uBAAA;EAfF;AACF;AAoBA;EAEE;IACE,iBAAA;IACA,uBAAA;EAnBF;AACF;AAuBA;EAGE;IACE,0BAAA;EAvBF;EA0BA;IACE,gBAAA;IACA,uBAAA;IACA,eAAA;IACA,iBAAA;IACA,kBAAA;EAxBF;AACF;AA6BA;EACE;IACE,sBAAA;EA3BF;EA8BA;IACE,sBAAA;EA5BF;AACF","sourcesContent":[".merchant-slide-section {\n  padding:0px 10%;\n  // margin-bottom:5%;\n}\n\n.slide-image {\n  width: 100px !important;\n  height: 100px;\n  object-fit: cover;\n  background-color: white;\n}\n.merchant-slide-text {\n  // width: 350px;\n  font-size: 45px;\n  line-height: 30px;\n}\n\n@media only screen and (max-width: 1811px) {\n  .Merchant-slide-container {\n    display: flex !important;\n  }\n\n  .merchant-slide {\n    display: flex !important;\n    flex-wrap: nowrap !important;\n    overflow: auto !important;\n    margin: 0 !important;\n    width:100%;\n    // padding-left: 15%;\n  }\n\n  .merchant-slide-text {\n    width: 100% !important;\n    \n  }\n  .text-break{\n    // padding-left:10% !important;\n  }\n\n}\n\n@media only screen and (max-width: 1545px) {\n\n\n  .merchant-slide-text {\n    width: 250px !important;\n  }\n\n  .merchant-slide-section {\n    margin-left: 0%;\n  }\n}\n\n@media only screen and (max-width: 992px) {\n  \n  .Merchant-slide-container{\n    display: inline !important;\n    padding:0px 10% !important;\n  }\n\n  .merchant-slide-text {\n    padding-left: 5% !important;\n    width: 250px !important;\n  }\n\n \n}\n\n@media only screen and (max-width: 820px) {\n\n  .merchant-slide-text {\n    padding-left: 10%;\n    width: 250px !important;\n  }\n\n}\n\n@media only screen and (max-width: 570px) {\n \n\n  .Merchant-slide-container{\n    display: inline !important;\n  }\n\n  .merchant-slide-text {\n    padding-left: 2%;\n    width: 500px !important;\n    font-size: 30px;\n    line-height: 15px;\n    margin-bottom: 10%;\n  }\n}\n\n\n\n@media only screen and (max-width: 559px) {\n  .Merchant-slide-container{\n    width:100% !important;\n  }\n\n  .merchant-slide-text{\n    width:100% !important;\n  }\n\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
